import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/ped/logoWhite.png'
import _imports_1 from '../assets/ped/tarja.jpg'
import _imports_2 from '../assets/ped/logoBlack.png'
import _imports_3 from '../assets/ped/cap.png'
import _imports_4 from '../assets/ped/celularCap.png'
import _imports_5 from '../assets/ped/energisa.png'
import _imports_6 from '../assets/ped/laptopEnergisa.png'
import _imports_7 from '../assets/ped/logoStAntonio.png'
import _imports_8 from '../assets/ped/laptopStAntonio.png'
import _imports_9 from '../assets/home/logo_branco.svg'
import _imports_10 from '../assets/home/linkedin.png'


const _withScopeId = n => (_pushScopeId("data-v-1928cb84"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "header",
  class: "flex column"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "logo",
    src: _imports_0,
    alt: "Logo"
  }),
  /*#__PURE__*/_createElementVNode("p", { id: "slogan" }, [
    /*#__PURE__*/_createTextVNode("Desenvolvimento de "),
    /*#__PURE__*/_createElementVNode("span", { class: "slogan_Orange" }, " Projetos"),
    /*#__PURE__*/_createTextVNode(" no âmbito do programa da ANEEL, em "),
    /*#__PURE__*/_createElementVNode("span", { class: "slogan_Orange" }, " colaboração"),
    /*#__PURE__*/_createTextVNode(" com as "),
    /*#__PURE__*/_createElementVNode("span", { class: "slogan_Orange" }, " universidades")
  ])
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tarja",
  src: _imports_1,
  alt: "Tarja"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "info",
  class: "flex column"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "logoInfo",
    src: _imports_2,
    alt: "Logo"
  }),
  /*#__PURE__*/_createElementVNode("p", { id: "text" }, [
    /*#__PURE__*/_createTextVNode("A studioApp desenvolve projetos de P&D no âmbito do programa da ANEEL (Agência Nacional de Energia Elétrica) como executora de soluções que necessitem de sistema web versátil, responsivo e inteligente; desempenho computacional; base de dados eficiente e armazenamento / computação em nuvem. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Em colaboração com equipes de Universidades renomadas como UFJF (Universidade Federal de Juiz de Fora) e PUC-Rio, a studioApp desenvolveu e vem desenvolvendo diversos P&D's para empresas como Energisa-MG, Energisa-PB, Santo Antônio Energia e INESC Brasil.")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tarja",
  src: _imports_1,
  alt: "Tarja"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tituloCarousel text-center text-h4 text-bold q-pb-lg q-pt-md no-margin" }, "Projetos desenvolvidos", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"flex":"1"},
  class: "flex column items-center justify-center"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logoProjetos",
    src: _imports_3,
    alt: "logo"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "tituloProjetos" }, "CAP Mobile"),
  /*#__PURE__*/_createElementVNode("p", { class: "subTituloProjetos" }, "Sistema de Captura de Dados de Modelos 3D")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"flex":"1"},
  class: "flex row"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    style: {"flex":"1"},
    class: "flex column"
  }, [
    /*#__PURE__*/_createElementVNode("p", { class: "textProjetos" }, [
      /*#__PURE__*/_createTextVNode("Desenvolvido por meio de um P&D da ANEEL celebrado pelo "),
      /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"800"} }, " INESC/Brasil"),
      /*#__PURE__*/_createTextVNode(" em parceria com a "),
      /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"800"} }, " UFJF"),
      /*#__PURE__*/_createTextVNode(", o aplicativo "),
      /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"800"} }, " CAP Mobile"),
      /*#__PURE__*/_createTextVNode(" gerencia o robô ("),
      /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"800"} }, "CAP"),
      /*#__PURE__*/_createTextVNode(") para a captura de dados de modelos 3D. O robô é posicionado no entorno do objeto a ser capturado e uma vez que a captura é iniciada e acompanhada pelo aplicativo, ocorre o mapeamento de dados da câmera e laser infravermelho em um modelo 3D, exibindo o resultado na tela do dispositivo mobile. A ferramenta permite ao usuário gerenciar e compartilhar as capturas em forma de projetos, diferencia a captura de objetos e de ambientes, possui uma galeria com as fotos de cada face do objeto capturado, visualização da imagem de planta baixa panorâmica do ambiente, função para calibração da câmera do robô, assim como a exibição do resultado final em forma de arquivos de modelo 3D. O aplicativo foi concebido para utilização no setor de energia como forma de auxiliar o processo de manutenção de subestações e de usinas de geração de energia.")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    style: {"flex":"0","margin-left":"5%"},
    class: "flex column"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "imgProjetos",
      src: _imports_4,
      alt: "logo"
    })
  ])
], -1))
const _hoisted_8 = {
  style: {"flex":"1"},
  class: "btnInfo flex justify-center"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Solicitar Informações")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"flex":"1"},
  class: "flex column items-center justify-center"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "logoEnergisa",
    src: _imports_5,
    alt: "logo"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "tituloProjetos" }, "Perdas Estocásticas"),
  /*#__PURE__*/_createElementVNode("p", { class: "subTituloProjetos" }, "Sistema de Cálculo de Perdas Estocásticas Regulatórias")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"flex":"1"},
  class: "flex row"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    style: {"flex":"1"},
    class: "flex column"
  }, [
    /*#__PURE__*/_createElementVNode("p", { class: "textProjetos" }, [
      /*#__PURE__*/_createTextVNode("Diante da necessidade de se calcular as perdas regulatórias para vários cenários estocásticos de geração, tarefa que demora vários dias, a "),
      /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"800"} }, " Energisa MG"),
      /*#__PURE__*/_createTextVNode(" iniciou em 2019 um projeto de P&D no âmbito da ANEEL. Desenvolvido em parceria com a Universidade Federal de Juiz de Fora ("),
      /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"800"} }, "UFJF"),
      /*#__PURE__*/_createTextVNode(") e a Pontifícia Universidade Católica do Rio de Janeiro ("),
      /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"800"} }, "PUC-Rio"),
      /*#__PURE__*/_createTextVNode("), a "),
      /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"800"} }, " studioApp"),
      /*#__PURE__*/_createTextVNode(" foi responsável pela elaboração de uma interface amigável, rápida e responsiva. Além disso, a "),
      /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"800"} }, " studioApp"),
      /*#__PURE__*/_createTextVNode(" desenvolveu um sistema robusto e inteligente para distribuição de tarefas a núcleos de processamento de um cluster que utiliza instâncias de computação de alta performance da "),
      /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"800"} }, " AWS"),
      /*#__PURE__*/_createTextVNode(". O resultado obtido foi uma solução eficiente, a qual apresentou uma redução significativa no tempo gasto para o cálculo de perdas estocásticas. Para um caso de 12 meses e 30 séries sintéticas, o cálculo leva menos de 3 horas para resolver os fluxos de potência dos sistemas de Baixa, Média e Alta Tensões (OpenDSS e Anarede®).")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    style: {"flex":"0","margin-left":"2%"},
    class: "flex column"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      id: "imgProjetosEnergisa",
      src: _imports_6,
      alt: "logo"
    })
  ])
], -1))
const _hoisted_12 = {
  style: {"flex":"1"},
  class: "btnInfo flex justify-center"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Solicitar Informações")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"flex":"1"},
  class: "flex column items-center justify-center"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "logoProjetosStAntonio",
    src: _imports_7,
    alt: "logo"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "tituloProjetos" }, "Calculador FID"),
  /*#__PURE__*/_createElementVNode("p", { class: "subTituloProjetos" }, "Controle de Indisponibilidade na Usina de Santo Antônio do Rio Madeira")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"flex":"1"},
  class: "flex row"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    style: {"flex":"1"},
    class: "flex column"
  }, [
    /*#__PURE__*/_createElementVNode("p", { class: "textProjetos" }, [
      /*#__PURE__*/_createTextVNode("Diante da necessidade de acompanhar, simular e otimizar os processos que afetam o cálculo do Fator de Disponibilidade (FID), a Santo Antônio Energia S.A. ("),
      /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"800"} }, "SAESA"),
      /*#__PURE__*/_createTextVNode(") iniciou, em 2020, um projeto de pesquisa e desenvolvimento no âmbito de P&D da ANEEL. Desenvolvido através de uma parceria entre a Universidade Federal de Juiz de Fora ("),
      /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"800"} }, "UFJF"),
      /*#__PURE__*/_createTextVNode(") e a "),
      /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"800"} }, "studioApp"),
      /*#__PURE__*/_createTextVNode(", o "),
      /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"800"} }, "Calculador FID"),
      /*#__PURE__*/_createTextVNode(" é uma plataforma que tem como objetivo a minimização de ocorrência de indisponibilidades nas Unidades Geradoras da Usina Hidrelétrica Santo Antônio. O Calculador FID é uma solução que busca informações nos diversos sistemas da usina (internos e externos), correlacionando-as e apontando possíveis melhorias para os indicadores componentes do cálculo do Fator de Disponibilidade.")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    style: {"flex":"0","margin-left":"5%"},
    class: "flex column"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      id: "imgProjetosStAntonio",
      src: _imports_8,
      alt: "logo"
    })
  ])
], -1))
const _hoisted_16 = {
  style: {"flex":"1"},
  class: "btnInfo flex justify-center"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Solicitar Informações")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tarja",
  src: _imports_1,
  alt: "Tarja"
}, null, -1))
const _hoisted_19 = {
  id: "footer",
  class: "column flex items-center"
}
const _hoisted_20 = { id: "form" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"white","font-size":"28px","text-align":"center","letter-spacing":"10px"} }, "SOLICITAR INFORMAÇÕES", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "hr1 q-mb-md" }, null, -1))
const _hoisted_23 = {
  class: "form_field",
  style: {"margin-right":"10px"}
}
const _hoisted_24 = { class: "form_field flex column" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "hr2 q-mb-md" }, null, -1))
const _hoisted_26 = {
  id: "rodape",
  class: "row flex items-center"
}
const _hoisted_27 = { class: "divfoot row flex items-end" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"128px"},
  src: _imports_9,
  alt: "Logo"
}, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  id: "email",
  style: {"color":"white"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bolder"} }, "E-mail"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("contato@studioapp.com.br")
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divfoot2 column flex" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"end","margin-bottom":"40px"} }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.linkedin.com/company/studioapp/",
      target: "_blank"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        style: {"width":"36px","height":"36px"},
        src: _imports_10,
        alt: "Linkedin"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center column" }, [
    /*#__PURE__*/_createElementVNode("p", { style: {"color":"white"} }, "© studioApp - 2021 | Todos os direitos reservados")
  ])
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  id: "ad",
  style: {"text-decoration":"none","align-self":"end","margin-right":"3%"},
  href: "https://www.amaiscriacao.com.br/",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "row flex" }, [
    /*#__PURE__*/_createElementVNode("p", { style: {"color":"white","margin-right":"5px","font-size":"10px"} }, "Designed by"),
    /*#__PURE__*/_createElementVNode("img", {
      style: {"width":"20px","height":"12px"},
      src: "https://static.wixstatic.com/media/dea8ea_9a6a9b63390345b8a17dfd74e3f4ab09.png/v1/fill/w_79,h_46,al_c,q_85,usm_0.66_1.00_0.01/dea8ea_9a6a9b63390345b8a17dfd74e3f4ab09.webp"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_carousel_slide = _resolveComponent("q-carousel-slide")!
  const _component_q_carousel = _resolveComponent("q-carousel")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, {
    id: "body",
    class: "column no-wrap"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createVNode(_component_q_carousel, {
        modelValue: _ctx.slide,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.slide) = $event)),
        arrows: "",
        animated: "",
        navigation: "",
        infinite: "",
        "control-text-color": "grey-9",
        "transition-prev": "scale",
        "transition-next": "scale",
        "control-color": "white",
        style: {"height":"100%"},
        class: "caroussel"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_carousel_slide, {
            name: "cap_mobile",
            class: "projetosBody"
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_q_btn, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showSolicitarInfo(_ctx.projetos[0]))),
                  color: "deep-orange-8"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_carousel_slide, {
            name: "energisa",
            class: "projetosBody"
          }, {
            default: _withCtx(() => [
              _hoisted_10,
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_q_btn, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSolicitarInfo(_ctx.projetos[1]))),
                  color: "deep-orange-8"
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_carousel_slide, {
            name: "fid",
            class: "projetosBody"
          }, {
            default: _withCtx(() => [
              _hoisted_14,
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_q_btn, {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showSolicitarInfo(_ctx.projetos[2]))),
                  color: "deep-orange-8"
                }, {
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        _withDirectives(_createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _hoisted_22,
          _createVNode(_component_q_form, {
            ref: "form",
            "no-wrap": "",
            onSubmit: _ctx.onSubmit,
            class: "qform row justify-center"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_q_select, {
                  modelValue: _ctx.formulario.projeto,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formulario.projeto) = $event)),
                  options: _ctx.projetos,
                  label: "Projeto",
                  "option-value": "name",
                  "option-label": "label",
                  "emit-value": "",
                  "map-options": "",
                  filled: "",
                  square: "",
                  "bg-color": "white",
                  loading: _ctx.loading,
                  rules: [ val => val && val.length > 0 || 'Esse campo deve ser preenchido !']
                }, null, 8, ["modelValue", "options", "loading", "rules"]),
                _createVNode(_component_q_input, {
                  filled: "",
                  square: "",
                  modelValue: _ctx.formulario.nome,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formulario.nome) = $event)),
                  label: "Seu nome",
                  "bg-color": "white",
                  "lazy-rules": "",
                  loading: _ctx.loading,
                  rules: [ val => val && val.length > 0 || 'Esse campo deve ser preenchido !']
                }, null, 8, ["modelValue", "loading", "rules"]),
                _createVNode(_component_q_input, {
                  filled: "",
                  square: "",
                  modelValue: _ctx.formulario.telefone,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formulario.telefone) = $event)),
                  label: "Telefone",
                  "lazy-rules": "",
                  "bg-color": "white",
                  loading: _ctx.loading,
                  mask: "(##) #####-####",
                  rules: [ val => val && val.length > 0 || 'Esse campo deve ser preenchido !']
                }, null, 8, ["modelValue", "loading", "rules"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_q_input, {
                  filled: "",
                  square: "",
                  type: "email",
                  modelValue: _ctx.formulario.email,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formulario.email) = $event)),
                  label: "Seu Email",
                  "lazy-rules": "",
                  loading: _ctx.loading,
                  "bg-color": "white",
                  rules: [val => !!val || 'Campo obrigatório',
                        val => _ctx.validEmail(val) || 'E-mail inválido']
                }, null, 8, ["modelValue", "loading", "rules"]),
                _createVNode(_component_q_input, {
                  filled: "",
                  square: "",
                  type: "textarea",
                  "input-style": {resize: 'none', height: '105px'},
                  modelValue: _ctx.formulario.mensagem,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formulario.mensagem) = $event)),
                  label: "Mensagem",
                  loading: _ctx.loading,
                  "lazy-rules": "",
                  "bg-color": "white",
                  rules: [ val => val && val.length > 0 || 'Esse campo deve ser preenchido !']
                }, null, 8, ["modelValue", "loading", "rules"]),
                _createVNode(_component_q_btn, {
                  style: {"width":"50px","align-self":"end","display":"flex","font-size":"12px","background-color":"#30A9EB"},
                  "text-color": "black",
                  size: "10px",
                  label: "Enviar",
                  type: "submit",
                  loading: _ctx.loading
                }, null, 8, ["loading"])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"]),
          _hoisted_25
        ], 512), [
          [_vShow, _ctx.viewSocilictarInfo]
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("a", {
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$router.push('/'))),
              style: {"cursor":"pointer"}
            }, _hoisted_29),
            _hoisted_30
          ]),
          _createVNode(_component_q_space),
          _hoisted_31
        ]),
        _hoisted_32
      ])
    ]),
    _: 1
  }))
}